import { useMemo } from "react";
import { Markdown } from "@/components/chat/Markdown";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { linkCitations } from "@/lib/research";
import { cn } from "@/lib/utils";

function CitationChip({ n, source }) {
  if (!source) return null;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <a href={source.url} target="_blank" rel="noopener noreferrer nofollow" className="cs-cite" data-testid={`citation-${n}`} aria-label={`Source ${n}: ${source.title}`}>
          {n}
        </a>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs border border-white/10 bg-ink-800 text-zinc-200">
        <div className="text-[12.5px] font-medium leading-snug">{source.title}</div>
        <div className="mt-0.5 text-[11px] text-zinc-500">{source.domain}</div>
      </TooltipContent>
    </Tooltip>
  );
}

export function ResearchReport({ text, sources, live = false }) {
  const byNumber = useMemo(() => Object.fromEntries((sources || []).map((s) => [s.n, s])), [sources]);
  const components = useMemo(
    () => ({
      a: ({ node, href, children, ...props }) => {
        const m = /^#cite-(\d+)$/.exec(href || "");
        if (m) return <CitationChip n={Number(m[1])} source={byNumber[Number(m[1])]} />;
        return <a href={href} {...props} target="_blank" rel="noopener noreferrer nofollow">{children}</a>;
      },
    }),
    [byNumber],
  );
  if (!text) return null;
  return (
    <div className={cn("cs-prose", live && "cs-caret")} data-testid="research-report">
      <Markdown content={linkCitations(text)} components={components} />
    </div>
  );
}
